import React, {Component} from 'react'
import { Link } from 'react-router-dom'
import PictureURL from '../static/default_picture_RM.jpg'
import { BookmarkButton, PDFButton} from './'
import { CardStyle, LongCardStyle } from './../styles'

export default class Cards extends Component {
  state = {
    isCOver: false,
  }

  defaultProps = {
    shadow: false,
    label: 'Discover',
  }

  componentDidMount () {
    const {card_picture, cover} = this.props
    this.img = new Image()
    this.img.src = card_picture ? card_picture : cover
    this.img.addEventListener('load', this.isVertical)
  }

  componentWillUnmount () {
    this.img.addEventListener('load', this.isVertical) 
  }

  isVertical = () => {
    this.setState({
      isCover: (this.props.slug.indexOf('friends-and-partners') !== -1 || this.props.slug.indexOf('materials') !== -1 || this.props.slug.indexOf('complications') !== -1) || this.img.naturalWidth > this.img.naturalHeight
    })
  
  }
  
  render () {
    const { 
      title, 
      cover,
      card_picture, 
      category, 
      slug, 
      pdfs, 
      description, 
      slug_bookmark, 
      type, 
      search, 
      highlight, 
      shadow, 
      is_bookmark,
      label
    } = this.props
    const {isCover} = this.state
    return (
      <div className={`card ${ search ? 
        LongCardStyle(
          shadow, 
          card_picture ? card_picture : cover ? cover : PictureURL,
          isCover
          ) 
       : CardStyle(
         shadow, 
         card_picture ? card_picture : cover ? cover : PictureURL,
         isCover
         )}`}>
        <div className='card-inner'>
          <Link to={slug}>
            <div className='card-picture'></div>
            <div className='card-info'>
              { category && <div className='card-info--type'> {category} </div> } 
              <h2> {title} </h2>
              { description && !search && <div className="description" dangerouslySetInnerHTML={{ '__html': description.length > 80 ? `${description.slice(0, 80)}...` : description }} /> }
              { search && <div className="highlight" dangerouslySetInnerHTML={{ '__html': highlight }} /> }
            </div>
            <div className='card-bottom flex items-center'>
              <span className='card-link'>{label}</span>
              <div className='card-button'>
                { pdfs && pdfs.length > 0 && (
                  <PDFButton pdfs={pdfs} big={search} />
                  ) 
                }
                { 
                  slug_bookmark && 
                  <BookmarkButton item={{slug_bookmark, type}} is_bookmark={is_bookmark} big={search} />
                }
              </div>
            </div>
          </Link>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Card.js